import { debounce } from 'lodash';
import React from 'react';
import { MBView } from '@shared/components/MBView';
import { MBScrollViewProps } from './props';

export class MBScrollView extends React.PureComponent<MBScrollViewProps> {
  scrollview: HTMLDivElement | null = null;

  scrollToTop() {
    this.scrollTo(0);
  }

  scrollToBottom() {
    if (!this.scrollview) {
      return;
    }
    this.scrollTo(this.scrollview.scrollHeight);
  }

  private scrollTo(offset: number) {
    if (!this.scrollview) {
      return;
    }
    this.scrollview.scrollTop = offset;
  }

  onScroll() {
    if (!this.scrollview) {
      return;
    }

    const sv = this.scrollview;

    if (!!this.props.onEndReached) {
      const scrollBottom = sv.scrollHeight - sv.scrollTop;
      const isNearBottom = scrollBottom <= sv.clientHeight;
      if (isNearBottom) {
        this.props.onEndReached();
      }
    }

    if (!!this.props.onStartReached) {
      const isNearTop = sv.scrollTop <= sv.clientHeight;
      if (isNearTop) {
        this.props.onStartReached();
      }
    }
  }

  componentDidMount() {}

  handleScroll = debounce(() => {
    if (this.scrollview) {
      this.onScroll();
    }
  }, 100);

  render() {
    const { horizontal, children, style, webScrollableDivStyle, webContentStyle, dataTestId } =
      this.props;

    return (
      <MBView flex style={style}>
        {/*
            Note: we use div instead of MBView because we can otherwise not
            get the correct ref to the scrollable view (aka div).

            Note: we debounce onScroll, otherwise performance is not great.
        */}
        <div
          ref={ref => (this.scrollview = ref)}
          onScroll={this.handleScroll}
          data-testid={dataTestId}
          style={{
            overflowX: horizontal ? 'auto' : undefined,
            overflowY: horizontal ? undefined : 'auto',
            overscrollBehavior: 'none',
            flex: 1,
            ...(webScrollableDivStyle as any),
          }}
        >
          <MBView row={horizontal} style={webContentStyle}>
            {children}
          </MBView>
        </div>
      </MBView>
    );
  }
}
